import React from 'react';
import { Shield } from 'lucide-react';
import {
  PRIVATE_ARCHIVE_HEADLINE,
  PRIVATE_ARCHIVE_POINTS,
} from '../../utils/archivePrivacyCopy';

/**
 * Explains that new archive connections are private placeholders until claimed.
 */
export function ArchiveConnectionPrivacyNotice({ compact = false, className = '' }) {
  return (
    <div
      className={`rounded-xl border border-[hsl(38_14%_86%)]/70 bg-[hsl(42_28%_99%)]/80 ${
        compact ? 'px-3 py-3' : 'px-4 py-4'
      } ${className}`}
      data-testid="archive-connection-privacy-notice"
    >
      <div className="flex gap-3">
        <Shield className="mt-0.5 h-4 w-4 shrink-0 text-[hsl(var(--studio-accent,38_36%_42%))]" aria-hidden />
        <div className="min-w-0 space-y-2">
          <p className={`font-serif ${compact ? 'text-sm' : 'text-[0.9375rem]'} text-foreground/88`}>
            {PRIVATE_ARCHIVE_HEADLINE}
          </p>
          <ul className="space-y-1.5 text-xs leading-relaxed text-muted-foreground">
            {PRIVATE_ARCHIVE_POINTS.map((line) => (
              <li key={line} className="flex gap-2">
                <span className="text-[hsl(var(--studio-accent,38_36%_42%))]/70" aria-hidden>
                  ·
                </span>
                <span>{line}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ArchiveConnectionPrivacyNotice;
